/**
 * ===============================================================================================================
 * ===============================================================================================================
 * CUSTOM CODE BY BYTES
 * ===============================================================================================================
 * ===============================================================================================================
*/

const urlParams = new URLSearchParams(window.location.search);
const product = urlParams.get('variant');
const productForm = document.querySelector('.product-form');
if( !product && productForm ) {
  console.log("!product && productForm");
  const variants = document.querySelectorAll('#hidden-variants [data-variant-id]');

    console.log("variants", variants);
    let has_third_option = false;
    productForm.querySelectorAll('.product-form__option-selector').forEach(function(option, index) {
      console.log("productForm.querySelectorAll('.product-form__option-selector')");
      const selected = option.querySelector('input[checked=checked]');
      const optionValues = option.querySelectorAll('input');
      if( optionValues.length > 1 ) {
        selected.removeAttribute('checked');
      }
    });
    variants.forEach(function(variant, index) {
      if(variant.getAttribute('data-option3')) {
        has_third_option = true;
        return;
      }
    });
    if( !has_third_option ) {
      variants.forEach(function(variant, index) {
        const option1 = variant.getAttribute('data-option1') ?? false;
        const option2 = variant.getAttribute('data-option2') ?? false;
        const option3 = variant.getAttribute('data-option3') ?? false;
        const available = variant.getAttribute('data-available') === 'false' ? false : true;
        if( !available && option1 && productForm.querySelector(`input[value="${option1}"][checked=checked]`) ) {
          if(option2) {
            productForm.querySelector(`input[value="${option2}"]`).parentElement.classList += ' is-disabled';
          }
          if(option3) {
            productForm.querySelector(`input[value="${option3}"]`).parentElement.classList += ' is-disabled';
          }
        }
        if( !available && option2 && productForm.querySelector(`input[value="${option2}"][checked=checked]`) ) {
          if(option1) {
            productForm.querySelector(`input[value="${option1}"]`).parentElement.classList += ' is-disabled';
          }
          if(option3) {
            productForm.querySelector(`input[value="${option3}"]`).parentElement.classList += ' is-disabled';
          }
        }
        if( !available && option3 && productForm.querySelector(`input[value="${option3}"][checked=checked]`) ) {
          if(option1) {
            productForm.querySelector(`input[value="${option1}"]`).parentElement.classList += ' is-disabled';
          }
          if(option2) {
            productForm.querySelector(`input[value="${option2}"]`).parentElement.classList += ' is-disabled';
          }
        }
      });
    }
}